import { render, staticRenderFns } from "./UserStartscreen.vue?vue&type=template&id=0350a768&"
import script from "./UserStartscreen.vue?vue&type=script&lang=js&"
export * from "./UserStartscreen.vue?vue&type=script&lang=js&"
import style0 from "./UserStartscreen.vue?vue&type=style&index=0&id=0350a768&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports